import styled from 'styled-components';

import { COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const Line = styled.div`
  flex: 1 1 0;
  min-width: 1px;
  border-top: 1px dashed ${COLORS.hairline};
`;

export const LabelText = styled(Text)`
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${COLORS.unlockLabel};
`;